import { Component, Input } from '@angular/core';
import { KeyboardScrollIntoViewDirective } from '@app/shared/directives/keyboard-scroll.directive';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'c-full-page-layout',
  imports: [SharedModule, KeyboardScrollIntoViewDirective],
  template: `
    <ion-header class="ion-no-border">
      <ion-toolbar [class.full-width]="config?.header?.fullWidth">
          <ng-content select="[full-page-header]"></ng-content>
      </ion-toolbar>
    </ion-header>
    <ion-content cKeyboardScrollIntoView [class.safe-area-bottom]="!hasFooter">
      <ng-content select="[full-page-content]"></ng-content>
    </ion-content>
    @if (hasFooter) {
      <ion-footer class="ion-no-border" [class.shadow]="config?.footer?.showBorder">
        <ion-toolbar class="footer-container">
          <ng-content select="[full-page-footer]"></ng-content>
        </ion-toolbar>
      </ion-footer>
    }
  `,
  styles: [
    `
      :host {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      ion-content {
        flex: 1 1 0%;
      }
      ion-header {
        ion-toolbar {
          &.full-width {
            --padding-start: 0;
            --padding-end: 0;
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      ion-toolbar {
        --background: white;
      }
      ion-content {
        overflow: auto;
        &.safe-area-bottom {
          --padding-bottom: var(--ion-safe-area-bottom);
        }
      }
      ion-footer {
        &.shadow {
          box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
        }
      }
    `
  ]
})
export class FullPageLayoutComponent {
  @Input() hasFooter = false;
  @Input() config = {
    header: {
      fullWidth: false,
    },
    footer: {
      showBorder: false
    }
  };
}
